
class BiographyEntry {

    startYear: number;
    endYear: number;
    content: string;
    images: Array<{
        url: string,
        link: string,
        title: string,
    }>;

    static fromJson(json: any): BiographyEntry {
        const bioEntry: BiographyEntry = new BiographyEntry();
        bioEntry.startYear = json.startYear;
        bioEntry.endYear = json.endYear;
        bioEntry.content = json.content;
        bioEntry.images = json.images
            .map((i: any) => {
                return {
                    url: i.image.data.attributes.formats.medium.url,
                    link: i.linkToArtwork,
                    title: i.title,
                }
            });
        return bioEntry;
    }
}

export default BiographyEntry;